// Geo-IP lookup for Int'l Phone Codes

var telInput = $("#phone");

// initialise plugin
telInput.intlTelInput({
  nationalMode: false,
  initialCountry: "auto",
  autoHideDialCode: true,
  allowDropdown: true,
  geoIpLookup: function(callback) {
    $.get('https://ipinfo.io', function() {}, "jsonp").always(function(resp) {
      var countryCode = (resp && resp.country) ? resp.country : "";
      callback(countryCode);
    });
  },
  utilsScript: "//www.justfitter.com/cdn/shop/t/8/assets/utils.js?v=2471352590011374641554258034"
});

// For exit intent popup
var telInputIC = $("#ic-phone");

telInputIC.intlTelInput({
  nationalMode: false,
  initialCountry: "auto",
  autoHideDialCode: true,
  allowDropdown: true,
  geoIpLookup: function(callback) {
    $.get('https://ipinfo.io', function() {}, "jsonp").always(function(resp) {
      var countryCode = (resp && resp.country) ? resp.country : "";
      callback(countryCode);
    });
  },
  utilsScript: "//www.justfitter.com/cdn/shop/t/8/assets/utils.js?v=2471352590011374641554258034"
});